import { Link } from "react-router-dom";
import { Tag, CalendarClock, UserCog, ArrowRight } from "lucide-react";
import { COMPANY, IMAGES } from "@/data";
import Reveal from "@/components/landing/Reveal";

const BENEFITS = [
  { icon: Tag, title: "Wholesale Pricing", desc: "Direct pricing on cabinets, countertops & materials for builders." },
  { icon: CalendarClock, title: "Priority Scheduling", desc: "Your projects move to the front of the line, every time." },
  { icon: UserCog, title: "Dedicated Project Manager", desc: "One point of contact managing every trade, start to finish." },
];

export const B2B = ({ variant = "full" }) => (
  <section
    id="builders"
    data-testid="b2b-section"
    className="relative bg-royal py-24 md:py-32 overflow-hidden"
  >
    <div className="absolute inset-0 noise-overlay" />
    <img
      src={IMAGES.blueprint}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover opacity-[0.08]"
    />
    <div className="relative max-w-[1440px] mx-auto px-5 md:px-12">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <Reveal>
            <span className="font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">
              Builder Partnership Program
            </span>
            <h2 className="mt-5 font-display font-bold uppercase text-white text-4xl md:text-6xl leading-[0.9] tracking-tight">
              {COMPANY.b2bTagline}
            </h2>
            <p className="mt-6 font-body text-white/70 text-lg max-w-md">
              Built for builders, GCs and property managers who need one reliable
              partner across every trade — with the pricing, scheduling and
              accountability to keep your projects on time and on budget.
            </p>
            {variant === "teaser" ? (
              <Link
                to="/builders"
                data-testid="b2b-teaser-btn"
                className="group mt-9 inline-flex items-center gap-2 rounded-full bg-gold hover:bg-gold-hover text-navy-dark font-bold uppercase tracking-wide text-sm px-8 py-4 transition-colors duration-200"
              >
                Explore the Builder Program
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-200" />
              </Link>
            ) : (
              <Link
                to="/contact"
                data-testid="b2b-cta-btn"
                className="group mt-9 inline-flex items-center gap-2 rounded-full bg-gold hover:bg-gold-hover text-navy-dark font-bold uppercase tracking-wide text-sm px-8 py-4 transition-colors duration-200"
              >
                Builder Partnership Inquiry
                <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform duration-200" />
              </Link>
            )}
          </Reveal>
        </div>

        <div className="space-y-5">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <Reveal key={b.title} delay={i * 0.1}>
                <div
                  className="glass bg-white/[0.08] border border-white/10 rounded-2xl p-6 flex items-start gap-5 hover:bg-white/[0.14] transition-colors duration-300"
                  data-testid={`b2b-benefit-${i}`}
                >
                  <div className="shrink-0 w-12 h-12 rounded-full bg-gold flex items-center justify-center">
                    <Icon size={22} className="text-navy-dark" />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-white text-xl">{b.title}</h3>
                    <p className="mt-1 font-body text-white/60 text-sm">{b.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);

export default B2B;
